import { instance } from 'shared/api/instance';
import { config } from 'shared/config';
import type {
  ISendCodeRequest,
  ISendCodeResponse,
  IConfirmCodeRequest,
  IConfirmCodeResponse,
  IVerificationError,
  IVkBindResponse,
  ICheckVkLinkResponse,
  ICheckBusinessVkLinkResponse,
} from '../interfaces/notification.interfaces';
import { AxiosError } from 'axios';

const API = instance(config.API_NOTIFICATION);

export const sendCode = async (
  data: ISendCodeRequest
): Promise<ISendCodeResponse> => {
  const res = await API.post<ISendCodeResponse>('verify/send-code', data);
  return res.data;
};

export const confirmCode = async (
  data: IConfirmCodeRequest
): Promise<IConfirmCodeResponse> => {
  const res = await API.post<IConfirmCodeResponse>('verify/confirm-code', data);
  return res.data;
};

export const bindVk = async (data: {
  phone: string;
  accountId?: string;
}): Promise<IVkBindResponse> => {
  const res = await API.post<IVkBindResponse>('verify/bind-vk', data);
  return res.data;
};

export const checkVkLink = async (
  phone: string
): Promise<ICheckVkLinkResponse> => {
  const res = await API.get<ICheckVkLinkResponse>('verify/check-vk-link', {
    params: { phone },
  });
  return res.data;
};

export const parseVerificationError = (
  error: unknown
): IVerificationError | null => {
  if (error instanceof AxiosError && error.response?.data) {
    const body = error.response.data as Record<string, unknown>;
    if (typeof body.message === 'string') {
      return {
        message: body.message as string,
        attemptsLeftInRound: body.attemptsLeftInRound as number | undefined,
        roundExhausted: body.roundExhausted as boolean | undefined,
        vkSendsLeft: body.vkSendsLeft as number | undefined,
        blocked: body.blocked as boolean | undefined,
        blockedUntil: body.blockedUntil as string | undefined,
        needsBind: body.needsBind as boolean | undefined,
      };
    }
  }
  return null;
};

export const checkBusinessVkLink = async (
  accountId: string
): Promise<ICheckBusinessVkLinkResponse> => {
  const res = await API.get<ICheckBusinessVkLinkResponse>(
    'verify/check-business-vk-link',
    {
      params: { accountId },
    }
  );
  return res.data;
};

export const unbindBusinessVk = async (
  accountId: string
): Promise<{ success: boolean }> => {
  const res = await API.post<{ success: boolean }>(
    'verify/unbind-business-vk',
    { accountId }
  );
  return res.data;
};

export const NotificationApi = {
  sendCode,
  confirmCode,
  bindVk,
  checkVkLink,
  checkBusinessVkLink,
  unbindBusinessVk,
  parseVerificationError,
};
